import styles, { stylesheet } from './Phone.scss'
import { withTranslation } from 'react-i18next'

import { Typography, Row, Box, Callout, FlexBox, Spinner, useScreenClass } from '@vp/swan'
import { DisabledPhone } from './DisabledPhone'
import useStatusChecker from '../../hooks/useStatusChecker'
import { useBannerStatusContext } from '../../contexts/StatusContext'
import { useStyles } from '@vp/ubik-context'

const Phone = (props) => {
  const { t, locale, tenant, contactChannels, proadvantageType, staticPhoneNumber } = props
  const lng = locale.toLowerCase().replace('-', '_')
  useStyles(stylesheet)
  const phoneNumber = contactChannels.phone.phoneNumber
  const proadvantagePhoneNumber = contactChannels.phone.proadvantagePhoneNumber
  const premiumProadvantagePhoneNumber = contactChannels.phone.premiumProadvantagePhoneNumber
  const schedule = contactChannels.phone.schedule
  const proadvantageSchedule = contactChannels.phone.proadvantageSchedule
  const premiumProadvantageSchedule = contactChannels.phone.premiumProadvantageSchedule

  const isProadvantage = proadvantageType !== ''
  const proadvantageNumber = proadvantageType === 'basic' ? proadvantagePhoneNumber : premiumProadvantagePhoneNumber
  const currentProadvantageSchedule = proadvantageType === 'basic' ? proadvantageSchedule : premiumProadvantageSchedule
  const { initialData } = useBannerStatusContext()

  const { data: status, isLoading: loading } = useStatusChecker(tenant, locale, initialData)

  if (loading) {
    return (
      <Spinner
        mt={{ lg: '7', md: '7', sm: '6', xs: '6' }}
        style={{ width: '100%' }}
        accessibleText={t(`${tenant}:search_results.preloader_accessibility_label`, { lng })}
        size="standard"
      />
    )
  }

  if (status?.enabled && status?.config?.phoneDisabled) return <DisabledPhone {...props} />

  const generatePhoneLink = (phoneNumber) => {
    const screenClass = useScreenClass()
    const isMobile = screenClass === 'xs' || screenClass === 'sm'

    if (!isMobile) {
      return (
        <Typography component="span" fontSize="large" fontWeight="bold">
          {phoneNumber}
        </Typography>
      )
    }

    return (
      <a href={`tel:${phoneNumber}`} style={{ textDecoration: 'none', color: 'inherit' }}>
        <Typography component="span" fontSize="large" fontWeight="bold">
          {phoneNumber}
        </Typography>
      </a>
    )
  }
  return (
    <Box paddingRight="2" className={styles.phoneColumnContainer}>
      <FlexBox justifyContent="space-between">
        <Row>
          <div style={{ display: 'flex' }}>
            <Typography fontSkin="title-subsection">{t(`${tenant}:phone.title`, { lng })}</Typography>
          </div>
        </Row>
        <Callout skin="standard">{t(`${tenant}:phone.badge`, { lng })}</Callout>
      </FlexBox>
      <Row pt="5">
        {staticPhoneNumber ? generatePhoneLink(staticPhoneNumber) : isProadvantage ? generatePhoneLink(proadvantageNumber) : generatePhoneLink(phoneNumber)}
      </Row>
      <Row pt="5" style={{ display: 'block' }}>
        {(isProadvantage ? currentProadvantageSchedule : schedule).map((element, index) => (
          <Typography key={index} component="span" fontSize="standard" style={{ display: 'block' }}>
            {element}
          </Typography>
        ))}
      </Row>
    </Box>
  )
}

export default withTranslation()(Phone)
